import Col from "components/ui-elements/Col";
import React from "react";
import DatepickerMy from "./DatepickerMy";

const DatepickerCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <DatepickerMy {...rest} />
    </Col>
  );
};

DatepickerCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default DatepickerCol;